/**
 * Линзы выдачи «Движа» (BS §11.4) — ряд чипов в шапке: «Для тебя», «Рядом»,
 * «Онлайн», «Новые» и линзы по собственным интересам. Один подбор, разные
 * срезы; выбранная линза подъезжает в видимую область.
 */
import { useEffect, useRef } from 'react'

import type { LensId, LensOption } from '@features/discovery/lenses'
import { Chip, cx } from '@shared/ui'

import styles from './dvizh.module.css'

interface LensBarProps {
  options: readonly LensOption[]
  value: LensId
  onChange: (lens: LensId) => void
  className?: string
}

export function LensBar({ options, value, onChange, className }: LensBarProps): React.ReactElement {
  const rowRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const selected = rowRef.current?.querySelector<HTMLElement>('[aria-pressed="true"]')
    selected?.scrollIntoView({ inline: 'nearest', block: 'nearest' })
  }, [value])

  return (
    <div ref={rowRef} className={cx(styles['lensBar'], className)} role="group" aria-label="Линза выдачи">
      {options.map((lens) => (
        <Chip
          key={lens.id}
          size="sm"
          icon={lens.icon}
          selected={lens.id === value}
          aria-pressed={lens.id === value}
          onClick={() => onChange(lens.id)}
          className={styles['lensChip']}
        >
          {lens.label}
        </Chip>
      ))}
    </div>
  )
}
